import { MutationTree } from 'vuex'

import { Invoice, InvoiceFilters } from '@/models'

import { OrderingState } from '../state'

export const ADD_INVOICE = 'ADD_INVOICE'
export const APPLY_INVOICE_FILTERS = 'APPLY_INVOICE_FILTERS'
export const INCREMENT_INVOICES_QUERY_INDEX = 'INCREMENT_INVOICES_QUERY_INDEX'
export const LOADED_ALL_INVOICES = 'LOADED_ALL_INVOICES'
export const RESET_INVOICES_QUERY_INDEX = 'RESET_INVOICES_QUERY_INDEX'
export const RESET_LOADED_ALL_INVOICES = 'RESET_LOADED_ALL_INVOICES'
export const SET_INVOICES_DEFAULT_FILTERS_FLAG = 'SET_INVOICES_DEFAULT_FILTERS_FLAG'
export const UPDATE_INVOICES = 'UPDATE_INVOICES'
export const UPDATE_INVOICES_TOTAL = 'UPDATE_INVOICES_TOTAL'

const mutations: MutationTree<OrderingState> = {
  [ADD_INVOICE] (state, invoice: Invoice) {
    state.invoices.elements.push(invoice)
  },

  [APPLY_INVOICE_FILTERS] (state, filters: InvoiceFilters) {
    const old = state.invoices.query

    state.invoices.query = {
      index: old.index,
      length: old.length,
      shopId: old.shopId,
      orderBy: old.orderBy,
      ...filters
    }
  },

  [INCREMENT_INVOICES_QUERY_INDEX] (state, offset: number) {
    state.invoices.query.index = (state.invoices.query.index ?? 0) + offset
  },

  [LOADED_ALL_INVOICES] (state) {
    state.invoices.didLoadAll = true
  },

  [RESET_INVOICES_QUERY_INDEX] (state) {
    state.invoices.query.index = 0
  },

  [RESET_LOADED_ALL_INVOICES] (state) {
    state.invoices.didLoadAll = false
  },

  [SET_INVOICES_DEFAULT_FILTERS_FLAG] (state, isDefaultFilters: boolean) {
    state.invoices.isDefaultFilters = isDefaultFilters
  },

  [UPDATE_INVOICES] (state, invoices: Invoice[]) {
    state.invoices.elements = invoices
  },

  [UPDATE_INVOICES_TOTAL] (state, total: number) {
    state.invoices.total = total
  }
}

export default mutations
